export { default as StationaryLinkCarousel } from './StationaryLinkCarousel';
